(function ($) {
  'use strict';

  const SLIDER_SELECTOR = '.js-hero-slider';

  function initSlider($slider) {
    const hasMultiple = $slider.children().length > 1;

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: hasMultiple,
      dots: false,
      infinite: true,
      autoplay: hasMultiple,
      autoplaySpeed: 6000,
      pauseOnHover: true,
    });
  }

  $(function () {
    if (typeof $.fn.slick !== 'function') {
      return;
    }

    $(SLIDER_SELECTOR).each(function () {
      initSlider($(this));
    });
  });
})(jQuery);
